export default __webpack_public_path__ + "static/media/2.1914f380.jpg";